import 'appstart';
import 'SCSSEntries/customerService.scss';
import 'left_menu';
import 'jquery-match-height';
AppLoader.ready(function () {
	$('.box-row .matchHeights').matchHeight({
		byRow: true,
		property: 'height',
	});
});
//AppLoader.setReady();